<template>
    <div class="wrapp">
        <div class="top"><h2>{{$t('home.perimetricLines')}}</h2></div>
        <div class="bottom">
            <img :src="image">
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory';

const SalonsRepository = RepositoryFactory.get('salons');
export default {
  name: 'MetricsLine',
  props: {
    image: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
    .bottom {
        max-height: 306px;

        img {
            display: block;
            width: 100%;
            height: 310px;
        }


    }

    h2 {
        /* color: #878a94; */
        font-size: rem(18px);
        font-weight: 800;
        text-transform: uppercase;
        text-align: left;
        padding: 29px 26px;
        margin: 0;
    }
</style>
